import { USER_DATA, USER_DETAILS } from '../utils/cookies/keys';
import convertColors from '../utils/theme/color-variant-naming';
import { THEME_COLORS } from '../utils/theme/colors';
import LoadingScreen from '../components/loading-screen';
import { RouterProvider } from 'react-router-dom';
import { ThemeProvider } from '@ebh/capsule/theme';
import useGetRecommenderData from '../api/hooks/cms/use-get-recommender-data';
import { router } from './routes';
import cookiesManager from '../utils/cookies';
import { ArrowBack } from '@vhc-portal/common/components';
import { Text } from '@ebh/capsule';
import { handleNavigation } from '../utils/handle-navigation';
import styles from './styles';

const ThemeLayout = () => {
  const grpId = cookiesManager.get(USER_DATA.GROUP_ID) || '';
  const isSso = cookiesManager.get(USER_DETAILS.IS_SSO) === 'true';
  const sourceType = cookiesManager.get(USER_DETAILS.SOURCE_TYPE);
  const url = import.meta.env.VITE_VHC_PORTAL_URL;
  const { recommenderData, isRecommenderLoading } = useGetRecommenderData({
    payload: { pageType: 'theme', collectionType: 'theme', groupId: grpId },
  });

  const colors = convertColors(
    recommenderData?.data?.[0]?.MetaData?.theme?.light?.colors || THEME_COLORS,
  );

  const handleSsoBack = () => {
    handleNavigation({
      url: url,
    });
  };

  if (isRecommenderLoading) {
    return <LoadingScreen />;
  }

  return (
    <ThemeProvider themeKey="vidal-vhc-portal" colors={colors}>
      {isSso && sourceType === 'VHC_PORTAL' && (
        <div onClick={handleSsoBack} css={styles.ssoHeader}>
          <ArrowBack size={20} style={styles.ssoHeaderIcon} />
          <Text variant="sub-heading-1" color="white">
            Back to Employee View
          </Text>
        </div>
      )}
      <RouterProvider router={router} />
    </ThemeProvider>
  );
};

export default ThemeLayout;
